<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" :title="title" width="800" @close="close" >
      <el-form  :model="formInline" class="demo-form-inline">
        <el-form-item  style="width:300px" label="物流单号">
          <el-input style="width:200px"  v-model="formInline.receiveNumber" disabled></el-input>
        </el-form-item>
        <el-form-item  style="width:300px" label="产品SKU">
          <el-input style="width:200px"  v-model="formInline.receiveMaterSku" disabled></el-input>
        </el-form-item>
        <el-form-item  style="width:300px" label="产品名称">
          <el-input style="width:200px"  v-model="formInline.receiveMaterName" disabled></el-input>
        </el-form-item>
        <el-form-item  style="width:300px" label="退回备注">
          <el-input disabled
                    v-model="formInline.remark"
                    style="min-width: 200px"
                    :autosize="{ minRows: 2, maxRows: 8}"
                    type="textarea"
                    placeholder="Please input"
          />
        </el-form-item>
        <el-form-item  style="width:300px" label="入库时间">
          <el-input style="width:200px"  v-model="formInline.CreateTime" disabled></el-input>
        </el-form-item>
        <el-form-item  style="width:300px" label="操作员">
          <el-input style="width:200px"  v-model="formInline.receivePerson" disabled></el-input>
        </el-form-item>
        <el-form-item v-if="mark" label="外包装图片">
          <myImage v-for="(item,index) in formInline.outerImage" :key="index"
                   :pictureUrl="item"
                   :pictureUrlList="formInline.outerImage"
                   :index="index"
          />
        </el-form-item>
        <el-form-item v-if="mark" label="设备通电图片">
          <myImage v-for="(item,index) in formInline.equipmentImage" :key="index"
                   :pictureUrl="item"
                   :pictureUrlList="formInline.equipmentImage"
                   :index="index"
          />
        </el-form-item>
        <el-form-item label="退货仓库">
          <div>
            <el-select
                disabled
                v-model="formInline.receiveWarehouseId"
                filterable
                reserve-keyword
                placeholder="请选择仓库"
                remote-show-suffix
                :loading="loading"
                style="width: 200px"
            >
              <el-option
                  v-for="item in stockList"
                  :key="item.warehousefCode"
                  :label="item.warehouseName"
                  :value="item.id"
              />
            </el-select>

          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script >
import {ElDialog, ElForm, ElFormItem,ElSelect,ElOption,ElInput} from "element-plus";
import {getFullUrl,isValidEmail,getLocalStockList} from "@/../public/js/index"
import myImage from "@/components/myImage.vue";
import {uploadUrl} from "@/utils/requset";
import {getReceiptInfo} from "@/utils/api"
export default {
  name: "receiptInfo",
  components:{
    ElDialog,ElForm,ElFormItem,ElSelect,ElOption,ElInput,myImage
  },
  mixins:[getFullUrl,isValidEmail],
  data(){
    return{
      dialogTableVisible:false,
      title:"退货质检|退货入库",
      mark:false,
      formInline:{
        receiveNumber:"",
        receiveMaterSku:"",
        receiveMaterName:"",
        remark:"",
        outerImage:[],
        equipmentImage:[],
        receiveWarehouseId:'',
        receiveWarehouse:'',
        receivePerson:'',
        CreateTime:'',
      },
      stockList:[],
      uploadUrl:'',
      dialogVisible:false
    }
  },
  beforeMount(){
    this.uploadUrl = uploadUrl
    this.getLocalStockList()
  },
  methods:{
    getReceiptInfo(){
      getReceiptInfo({receiveSaleNumber:this.formInline.receiveSaleNumber}).then(res=>{
        this.formInline = res.Data
        if(res.Data.remark) {
            this.mark = res.Data.remark.includes('30天内退') || res.Data.remark.includes('不满意')
        }
        if(res.Data.receiveWarehouse=="835-美国售后仓-待报废仓" || res.Data.receiveWarehouse=="836-美国售后仓-待退回国内") {
          this.mark = true
        }
      }).catch(err=>{
        console.log(err)
      })
    },
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res.filter(item=>{
          return item.warehouseName.includes("美国售后仓")
        })
      })
    },
    open(data){
      console.log(data)
      this.dialogTableVisible=true
      this.formInline = {
        receiveSaleNumber:data.receiveSaleNumber,
        receiveNumber:data.receiveNumber,
        receiveMaterSku:"",
        receiveMaterName:"",
        remark:"",
        outerImage:[],
        equipmentImage:[],
        receiveWarehouseId:'',
        receiveWarehouse:'',
        receivePerson:'',
        CreateTime:'',
      }
      this.formInline.remark = data.receiveRemarks
      this.getReceiptInfo()
    },
    close(){
      this.dialogTableVisible = false
      this.$emit('closeEdit')
    },
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 100px;
}
.span{
  color: #f56c6c;
  font-size: 12px;
}
</style>